/* src/util/file.js */

import PapaParse from 'papaparse/papaparse.min';
import { dropRightWhile, flatten, isEmpty } from 'lodash';
import { createSelector } from 'reselect';

export const parseCSV = csv => new Promise((resolve, reject) => {
  const reader = new FileReader(); // eslint-disable-line
  reader.onload = e => {
    const parsed = PapaParse.parse(e.target.result, {
      error: reject,
    });
    resolve(dropRightWhile(
      parsed.data,
      l => isEmpty(l) || (l.length === 1 && isEmpty(l[0]))
    ));
  };
  reader.readAsText(csv);
});

// format: [subject]|[number]&...&[number];...;[subject]|[number]
export const parseCourseString = courseString => flatten(courseString
  .split(';')
  .map(g => g.split('|').map(m => m.split('&')))
  .map(x => {
    if (x.length !== 2) return false;
    const subject = x[0][0];
    return x[1].map(number => ({ subject, number }));
  }));

export const createPageSelector = type => createSelector(
  state => state[type].pagination,
  ({ page, currentPageCount, limit }) => {
    const start = (page - 1) * limit + 1;
    return {
      page,
      limit,
      start,
      end: start + currentPageCount - 1,
    };
  }
);



// WEBPACK FOOTER //
// ./src/util/file.js